// src/shared_new/components/PerlImage.jsx
// Reusable Image Display Component with Perl Theme

import React from "react";
import { Box, Paper, CircularProgress, Typography } from "@mui/material";
import { theme } from "../../design/theme";

const { perlColors } = theme.custom;

/**
 * PerlImage - Display product image with loading state
 *
 * @param {Object} props
 * @param {string} props.imageUrl - URL of the image to display
 * @param {boolean} props.loading - Loading state
 * @param {string} props.alt - Alt text for image
 * @param {number} props.height - Height of image container (default: 400)
 * @param {Object} props.sx - Additional styles
 */
export default function PerlImage({
  imageUrl,
  loading = false,
  alt = "Product Image",
  height = 400,
  sx = {},
  onImageError,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 2,
        overflow: "hidden",
        border: `1px solid ${perlColors.border}`,
        bgcolor: perlColors.surface,
        height: height,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        ...sx,
      }}
    >
      {loading ? (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
          <CircularProgress sx={{ color: perlColors.brand }} />
          <Typography sx={{ color: perlColors.textSecondary }}>Generating image...</Typography>
        </Box>
      ) : imageUrl ? (
        <Box
          component="img"
          src={imageUrl}
          alt={alt}
          onError={onImageError}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            borderRadius: 2,
          }}
        />
      ) : (
        <Typography sx={{ color: perlColors.textSecondary }}>No image available</Typography>
      )}
    </Paper>
  );
}
